'use client';

import { ClickableDiv } from '@wwe-portal/ui/components/button';
import {
  CommonDialogLayout,
  createPortableDialog,
  Dialog,
  usePortableDialog,
} from '@wwe-portal/ui/components/dialog';
import ConnectTwitch from '@wwe-portal/web/components/layout/right-sidebar/connect-twitch';
import DisconnectTwitch from './disconnect-twitch';
import Image from 'next/image';
import { useGetCurrentUser } from '@wwe-portal/web/providers/queries/user-info';

const TwitchDialogUI = ({ open, onClose }) => {
  const userInfo = useGetCurrentUser();
  const twitchAccount = userInfo?.twitchUser ?? '';
  return (
    <Dialog
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose?.();
      }}
      open={open}
    >
      <CommonDialogLayout
        actionElement={
          <ClickableDiv className="w-full rounded-md bg-[#7c45f8] py-3">
            {twitchAccount ? <DisconnectTwitch /> : <ConnectTwitch />}
          </ClickableDiv>
        }
        closable
        dataId="OutStockClubCoinDialog"
        descriptionElement={
          <p className="text-text400 mt-2 text-base font-medium">
            {twitchAccount ?? 'Enter your Twitch channel link'}
          </p>
        }
        hasBackground
        imageElement={
          <Image
            src={`/assets/${twitchAccount ? 'TwitchIn' : 'stream-settings'}.png`}
            alt="stream"
            className="rounded-full"
            width={150}
            height={150}
          />
        }
        layoutClass="px-6"
        onClose={onClose}
        titleElement={
          twitchAccount ? null : (
            <p className="mt-2 text-xl font-semibold leading-6">
              Stream Settings
            </p>
          )
        }
      />
    </Dialog>
  );
};

export const TwitchDialog = createPortableDialog(() => {
  const modal = usePortableDialog();
  return <TwitchDialogUI open={modal.visible} onClose={modal.remove} />;
});
